/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
  message,
  InputNumber,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import { getEstadosGlobales } from 'api/catalogos/index';

// Importa aquí tu servicio para el Catálogo de Carácter de Nombramiento (Tipos)
// import { getCaracteresDeNombramiento } from 'api/catalogos/caracteresDeNombramiento';

import {
  getConfiguracionesNombramientos,
  postConfiguracionNombramiento,
  deleteConfiguracionNombramiento,
  patchConfiguracionNombramiento,
  getConfiguracionNombramiento,
  autorizarConfiguracionNombramiento,
} from 'api/catalogos/ConfiguracionNombramientos';

import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getCaracteresDeNombramiento } from 'api/catalogos/CaracterDeNombramiento';

export const configuracionnombramientoPermission = {
  permissionModel: 'configuraciondenombramiento',
  catalogsModels: [],
  tabsModels: [],
};

const ConfiguradorNombramientos = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  // const [tiposNombramiento, setTiposNombramiento] = useState([]);
  const [caracteresNombramientos, setCaracteresNombramientos] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const nameCaracterNombramiento = 'caracter_de_nombramiento';

  const formInstances = [form];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getConfiguracionesNombramientos();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();

      const [
        _estados,
        _data,
        // _tiposNombramiento,
        _caracteresNombramientos,
      ] = await Promise.all([
        getEstadosGlobales(),
        getConfiguracionesNombramientos(),
        // Promise.resolve([]), // <-- AQUI COLOCA LA LLAMADA AL API DE TIPOS DE NOMBRAMIENTO
        getCaracteresDeNombramiento(),
      ]);

      if (mounted) {
        setEstados(_estados);
        setData(formatReceived(_data));
        setCaracteresNombramientos(_caracteresNombramientos);
        // setTiposNombramiento(_tiposNombramiento);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _configuracion = await getConfiguracionNombramiento(match.id);

    setTimeout(() => {
      if (_configuracion) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_configuracion));
          setDisableFields(_configuracion?.estados_globales !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;

      // eslint-disable-next-line max-len
      const saved = await (key ? patchConfiguracionNombramiento(key, values) : postConfiguracionNombramiento(values));

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteConfiguracionNombramiento(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una configuración ya autorizada');
        return;
      }
      const saved = await autorizarConfiguracionNombramiento(key);
      if (saved) {
        const _data = await getConfiguracionesNombramientos();
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    // {
    //   titleText: 'Tipo de Nombramiento',
    //   dataIndex: 'tipo_nombramiento_id',
    //   key: 'tipo_nombramiento_id',
    //   width: 300,
    //   render: (val) => tiposNombramiento.find((t) => t.id === val)?.nombre || val,
    // },
    {
      titleText: 'Carácter de Nombramiento',
      dataIndex: nameCaracterNombramiento,
      key: nameCaracterNombramiento,
      width: 300,
      render: (val) => caracteresNombramientos.find((t) => t.id === val)?.descripcion || val,
    },
    {
      titleText: 'Días Previos para Renovación',
      dataIndex: 'maximo_de_dias_previos_para_renovar',
      key: 'maximo_de_dias_previos_para_renovar',
      width: 250,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 200,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    dias_previos: [
      requiredRule,
      {
        type: 'number',
        min: 0,
        message: 'Debe ser un número entero válido',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'configuraciondenombramiento', action: 'autorizar' },
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              disabledBySelection: true,
              disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
              className: 'success',
            },
          ]}
          disableDelete={selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width={600}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Configurador de Nombramientos`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableFields}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="configurador_nombramientos"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name={nameCaracterNombramiento}
                rules={rules.required}
                label="Carácter de Nombramiento"
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={caracteresNombramientos}
                  disabled={disableFields}
                  placeholder="Selecciona el Carácter de Nombramiento"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="maximo_de_dias_previos_para_renovar"
                rules={rules.dias_previos}
                label="Días Previos para Renovación"
                hasFeedback
              >
                <InputNumber
                  style={{ width: '100%' }}
                  disabled={disableFields}
                  placeholder="Ej. 5"
                  min={0}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="vigencia_final"
                label="Vigencia Final"
                hasFeedback
              >
                <DatePicker
                  style={{ width: '100%' }}
                  disabled={selectedRowKeys?.length === 0
                    || selectedData?.estados_globales === ESTATUS_INACTIVO}
                  placeholder="Seleccionar fecha"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estado"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  activeInactive={selectedData?.estados_globales === ESTATUS_ACTIVO}
                  disabled={selectedRowKeys.length <= 0 || disableFields}
                  onChange={(val) => setVisibleConfirmInactivo(val === ESTATUS_INACTIVO)}
                />
              </Form.Item>
            </Col>

            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content="Configuración seleccionada"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle="Autorizar la Configuración"
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle="Inactivar la Configuración"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ConfiguradorNombramientos;
